import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=e69f1c0c&scoped=true"
import script from "./UserItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UserItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=e69f1c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69f1c0c",
  null
  
)

export default component.exports